import { useHistory, useParams } from 'react-router-dom';
import { AgencyPermissionEnums } from 'shared/enums/AgencyPermissionEnums';
import { EMediaTabs } from 'shared/enums/EMediaTabs';
import { useEditProfileMedia } from '../context/EditProfileMediaProvider';
import { useEffect, useState } from 'react';
import { ROUTES } from 'shared/constants/ROUTES';

type TabsProps = {
  name: string;
  value: EMediaTabs;
  hide?: boolean;
};

const url_tabs = ['media_documents', 'resume', 'composite_card'];

export const useEditProfileMediaTab = (handleIsCompositeCard: (value: boolean) => void) => {
  const { isPermissionGranted } = useEditProfileMedia();
  const history = useHistory();
  const { tabs: tab, id } = useParams() as { tabs: EMediaTabs; id: string };
  const is_composite_card_granted = isPermissionGranted(AgencyPermissionEnums.COMPOSITE_CARD);

  const [currentTab, setCurrentTab] = useState<EMediaTabs>(
    !url_tabs.includes(tab) || (tab === EMediaTabs.COMPOSITE_CARD && !is_composite_card_granted)
      ? EMediaTabs.MEDIA_DOCUMENTS
      : tab,
  );

  const handleOnChange = (value: EMediaTabs) => {
    setCurrentTab(value);
    window.history.pushState({}, '', `${ROUTES.TALENT.REPRESENTATIVES}/${id}/${value}`);
    handleIsCompositeCard(value === EMediaTabs.COMPOSITE_CARD);
  };

  const tabs: TabsProps[] = [
    {
      name: 'Media/Documents',
      value: EMediaTabs.MEDIA_DOCUMENTS,
    },
    {
      name: 'Resume',
      value: EMediaTabs.RESUME,
    },
    {
      name: 'Composite Card',
      value: EMediaTabs.COMPOSITE_CARD,
      hide: !is_composite_card_granted,
    },
  ];

  useEffect(() => {
    if (!url_tabs.includes(tab) || (tab === EMediaTabs.COMPOSITE_CARD && !is_composite_card_granted)) {
      history.replace(`${ROUTES.TALENT.REPRESENTATIVES}/${id}/${EMediaTabs.MEDIA_DOCUMENTS}`);
      setCurrentTab(EMediaTabs.MEDIA_DOCUMENTS);
    }
    handleIsCompositeCard(tab === EMediaTabs.COMPOSITE_CARD && is_composite_card_granted);
  }, []);

  return { tabs, currentTab, handleOnChange };
};
